<template>
    <div class="flex gap-3 py-1 border-b border-gray-100">
        <span class="w-44 shrink-0 text-gray-500">{{ label }}</span>
        <span class="text-gray-800">{{ value || '—' }}</span>
    </div>
</template>

<script setup>
defineProps({
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
})
</script>
